export const api = {
  getRecordList:"/bas/emergency/queryEmergencyHistoryRecordList.json",//get 预案执行记录list
  getRecordDetail:"/bas/emergency/queryEmergencyHistoryRecordDetail.json",//get预案执行记录detail
  getSubRecordDetail:"/bas/emergency/queryEmergencySubRecordDetail.json",//get 预案执行记录子记录
}